<template>
  <div>
    <div class="row">
      <div v-for="(card) in cards" :key="card.title">
        <div :class="{lightgrey: index % 2 === 0}" class="col s12">
          <div class="col s12 m10 l8 offset-m1 offset-l2">
            <h2 class="header">{{$t(card.title)}}</h2>
            <div class="card horizontal">
              <div class="card-image">
                <img :src="card.img.link" :alt="$t(card.img.alt)"/>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <p v-html="$t(card.desc)"></p>
                  <div class="chip" v-for="(tag) in card.tags" :key=tag>{{tag}}</div>
                </div>
                <div class="card-action" :class="{hide: card.action === '' }"><p v-html="$t(card.action)"></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Experience',
  data () {
    return {
      cards: [{
        title: 'experience.cdiscount.title',
        img: {link: 'static/img/cdiscount.jpg', alt: 'experience.cdiscount.alt.pict'},
        desc: 'experience.cdiscount.desc',
        action: 'experience.cdiscount.action',
        tags: ['Scrum', 'React JS', 'React Native', 'Java', 'Android', 'Swift', 'Objective C']
      }, {
        title: 'experience.packid.title',
        img: {link: 'static/img/packid.webp', alt: 'experience.packid.alt.pict'},
        desc: 'experience.packid.desc',
        action: 'experience.packid.action',
        tags: ['eXtreme Programming', 'Java', 'Java Android', 'Swift', 'Kotlin', 'AES', 'RSA', 'Bluetooth', 'NFC', 'MySQL']
      }, {
        title: 'experience.gingisoft.title',
        img: {link: 'static/img/team_work.png', alt: 'experience.gingisoft.alt.pict'},
        desc: 'experience.gingisoft.desc',
        action: '',
        tags: ['PHP 7', 'Symfony 3', 'Angular JS', 'MongoDb']
      }, {
        title: 'experience.proximit.title',
        img: {link: 'static/img/proximit.svg', alt: 'experience.proximit.alt.pict'},
        desc: 'experience.proximit.desc',
        action: 'experience.proximit.action',
        tags: ['PHP 7', 'Symfony 3', 'IONIC', 'MySQL']
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Experience.vue